var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPausefill(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 15,
    viewBox: "0 0 12 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.63184 14.9668H3.69727C4.53223 14.9668 4.96289 14.5361 4.96289 13.7012V1.60742C4.96289 0.754883 4.53223 0.350586 3.69727 0.341797H1.63184C0.796875 0.341797 0.366211 0.772461 0.366211 1.60742V13.7012C0.357422 14.5361 0.788086 14.9668 1.63184 14.9668ZM8.31152 14.9668H10.3682C11.2031 14.9668 11.6338 14.5361 11.6338 13.7012V1.60742C11.6338 0.754883 11.2031 0.341797 10.3682 0.341797H8.31152C7.46777 0.341797 7.0459 0.772461 7.0459 1.60742V13.7012C7.0459 14.5361 7.46777 14.9668 8.31152 14.9668Z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPausefill);
export default __webpack_public_path__ + "static/media/pause.fill.83f5f07e.svg";
export { ForwardRef as ReactComponent };